import './rules/index.sass';
import './support/index.sass';
import './contacts/index.sass';
import './about/index.sass';
import './albums-upload';
import './product-upload';
import './dialog_members/inputEmoji';
import './away/index.sass';

import Illustrations from './illustrations';
import initIllustrationPage from './illustration-page';
import initRegistration from './registration';
import initNotificationPage from './notification';
import initBlog from './blog';
import initSinglePost from './single-post';
import initNewPost from './new-post';
import initJobs from './jobs';
import initUsers from './users';
import initSingleJobs from './single-jobs';
import initNewJob from './new-job';
import initContests from './contests';
import initContestsPage from './contests-page';
import initFeeds from './feeds';
import initSearch from './search';
import initProfile from './profile';
import initCourses from './courses';
import initDialogMembers from './dialog_members';
import initSorting from './sorting';
import initSettings from './settings';
import initChallenge from './challenge';
import initUpload from './upload';
import initMart from './mart';
import initPremium from './premium_accounts';

export default () => {
  initJobs();
  initRegistration();
  initContests();
  initContestsPage();
  initCourses();
  initDialogMembers();
  initPremium();

  const $illustrations = $('.illustrations, .mart');
  const $illustrationsPage = $('.illustration-page');
  const $blog = $('.blog');
  const $singlePost = $('.single-post');
  const $newPost = $('.new-post');
  const $users = $('.users');
  const $singleJobs = $('.single-jobs');
  const $newJob = $('.new-job');
  const $feeds = $('.feeds');
  const $search = $('.search');
  const $sorting = $('.sorting');
  const $settings = $('.settings');
  const $upload = $('.upload');
  const $albumsUpload = $('.albums-upload');
  const $mart = $('.mart');
  const $profile = $('.profile');
  const $challenge = $('.challenge');
  const $notification = $('.notification');
  const $showEngField = $('.js-eng-version-field');

  $illustrations.length && new Illustrations($illustrations);
  $illustrationsPage.length && initIllustrationPage();
  $notification.length && initNotificationPage();
  $blog.length && initBlog($blog);
  $singlePost.length && initSinglePost();
  $newPost.length && initNewPost();
  $users.length && initUsers();
  $singleJobs.length && initSingleJobs();
  $newJob.length && initNewJob();
  $feeds.length && initFeeds();
  $search.length && initSearch();
  $sorting.length && initSorting();
  $settings.length && initSettings();
  $upload.length && initUpload();
  $mart.length && initMart($mart);
  $profile.length && initProfile($profile);
  $challenge.length && initChallenge($challenge);
  // $albumsUpload.length && initAlbumsUpload();

  if($showEngField.length) {
    $showEngField.on('click', function(){
      $(this)
        .slideUp()
        .next()
        .slideDown();
    })
  }
}
